<template>
    <div class="escort-profile-component" :class="{'fill-height-while-loading': isLoadingProfile}">
        <div class="profile-loading-container" v-if="isLoadingProfile">
            <div class="col-12 justify-content-center loading-spinner">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ translate.home.loading }}...</span>
                </div>
                <span>{{ translate.home.loading }}...</span>
            </div>
        </div>

        <modal-blurred-profile :profile-user="user" ref="modalBlurredProfile"></modal-blurred-profile>

        <ModalProfileAdvertPopUpComponent
            v-if="showAdvertPopup"
            :adverts="user ? user.profileAdverts : []"
            @skip="onAdvertPopupSkip"
            @close="onAdvertPopupClose"
        />

        <ModalPunterLoginOrRegisterComponent></ModalPunterLoginOrRegisterComponent>

        <modal-subscribe-to-private-gallery ref="privateGalleryModal"
                                            @galleryPurchased="refreshComponent"/>
        <modal-private-gallery-contents ref="galleryContentsModal"/>
        <modal-purchase-all-galleries ref="purchaseAllModal" :user="user" @galleryPurchased="refreshComponent"/>

        <modal-login-or-register-for-private-gallery ref="loginOrRegisterModal" @refreshComponent="refreshComponent"/>
        <modal-gallery-guest-purchase-success ref="galleryGuestPurchaseSuccess"></modal-gallery-guest-purchase-success>

        <ModalTipSelectAmountComponent ref="tipSelectAmountModal" :user="user" @amountSelected="onTipAmountSelected"/>
        <ModalTipConfirmPurchaseComponent ref="tipConfirmModal" @tipSuccess="onTipSuccess"/>
        <ModalTipSuccessComponent ref="tipSuccessModal"/>
        <ModalTipAuthComponent ref="tipAuthModal"/>

        <inactive-profile-banner v-if="profileIsInactive && !this.isGoldUser(user)"
                                 :user="user"></inactive-profile-banner>
        <profile-blurred-banner-component v-if="profileUserIsCurrentUserAndBlurred"
                                          e2e-id="profile-blurred-banner"></profile-blurred-banner-component>
        <modal-your-profile-is-blurred v-if="profileUserIsCurrentUserAndBlurred"></modal-your-profile-is-blurred>

        <div v-if="user && user.breadcrumbs" class="profile-breadcrumbs d-none d-sm-block">
            <ProfileBreadcrumbsComponent :user="user"/>
        </div>

        <ProfileHeaderNavigationComponent
            :show-location="areUserCoordinatesSet || showOutcallLocation"
            :show-reviews="true"
            :show-about="!!getAboutMe()"
            :show-services="lodash.get(user,'services',[]).length > 0"
            :show-prices="lodash.get(user,'prices',[]).length > 0"
            :show-tip-me="!isSeekingServicesProfile"
            @tip-click="openTipSelectAmountModal"
        />

        <div class="row limit-profile-page-width user-profile-component-content" v-show="user"
             :class="{'limit-profile-page-width--inactive': profileIsInactive,
             'limit-profile-page-width--blurred': profileUserIsCurrentUserAndBlurred,
             'visibility-hidden': isLoadingProfile}">

            <div class="col-md-12" v-if="isUserAdmin">
                <div class="outcall-locations-container limit-profile-page-width mb-3 d-flex p-2 align-items-baseline">
                    <span>{{ translate.account.searchLocationsProfileAppearsIn }} {{ outcallLocationsForAdmin }}</span>
                </div>
            </div>

            <modal-report-profile :reported-user-id="user ? user.id : 0"></modal-report-profile>
            <ModalWriteReviewComponent :user="user" @reviewCreated="onReviewCreated"></ModalWriteReviewComponent>

            <div class="col-md-12 mb-4">
                <div class="main-profile-container container-box-desktop">
                    <div class="main-profile-container--gallery" :class="{'visibility-hidden': isLoadingProfile}">
                        <div id="profile-image-slider" class="carousel slide" data-ride="carousel">

                            <span v-if="(photosToShow.length) > 0"
                                  class="profile-image-wrapper">

                        <div class="carousel-indicator-wrapper">
                            <span v-if="showScrollArrows" @click="carouselPrev()"
                                  class="carousel-arrow-indicator carousel-arrow-indicator--up">
                                <icon-component :icon="fa_angle_up()"></icon-component>
                            </span>

                            <ol class="carousel-indicators">
                                <template
                                    v-for="(photo,index) in photosToShow">

                                    <!-- Regular video -->
                                    <li
                                        v-if="photo.video_id"
                                        :key="index"
                                        :class="['carousel-indicator-item-' + index]"
                                        data-target="#profile-image-slider"
                                        :data-slide-to="getPhotosRealPosition(index)">
                                        <picture v-if="!isMediaExplicit(photo)" e2e-id="profile-photo-thumbnail"
                                                 class="position-relative">
                                            <source :srcset="getVideoThumbnailUrl(user,'webp','p-small', photo)"
                                                    type="image/webp">
                                            <source :srcset="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                    type="image/jpeg">
                                            <img class="d-block"
                                                 :src="getVideoThumbnailUrl(user,'jpg','p-small', photo)"
                                                 @load="initializePhotoScroll" :alt="'Video #' + (index + 1)"
                                                 width="87" height="116"/>

                                            <div class="profile-video-container">
                                                <div class="profile-video-block">
                                                    <button class="profile-video-button">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                             fill="currentColor" aria-hidden="true">
                                                            <path
                                                                d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </picture>
                                        <explicit-photo-placeholder v-else
                                                                    class="explicit-photo-placeholder--thumbnail"
                                                                    e2e-id="profile-photo-thumbnail-explicit"
                                                                    :show-action-buttons="false"/>
                                    </li>
                                    <!-- Regular video end-->

                                    <!-- Regular Photos -->
                                    <li
                                        v-else
                                        :key="index"
                                        :class="[{active: index === 0}, 'carousel-indicator-item-' + index]"
                                        data-target="#profile-image-slider"
                                        :data-slide-to="getPhotosRealPosition(index)">
                                        <template v-if="!photo.galleryId">
                                            <picture v-if="!isMediaExplicit(photo)" e2e-id="profile-photo-thumbnail">
                                                <source :srcset="getPhotoUrl(user,'webp','small', index)"
                                                        type="image/webp">
                                                <source :srcset="getPhotoUrl(user,'jpg','small', index)"
                                                        type="image/jpeg">
                                                <img class="d-block" :src="getPhotoUrl(user,'jpg','small', index)"
                                                     @load="initializePhotoScroll" :alt="'Photo #' + (index + 1)"
                                                     width="87" height="116"/>
                                            </picture>
                                            <explicit-photo-placeholder v-else
                                                                        class="explicit-photo-placeholder--thumbnail"
                                                                        e2e-id="profile-photo-thumbnail-explicit"
                                                                        :show-action-buttons="false"/>
                                        </template>
                                        <picture v-if="photo.galleryId">
                                            <source :srcset="photo.urls.small.webp" type="image/webp">
                                            <source :srcset="photo.urls.small.jpg" type="image/jpeg">
                                            <img class="d-block" :src="photo.urls.small.jpg" :alt="'Photo'"
                                                 @load="initializePhotoScroll" width="87" height="116"/>
                                        </picture>
                                    </li>
                                    <!-- Regular Photos end -->


                                    <!-- Private Gallery Purchase (single placeholder for all galleries) -->
                                    <li v-if="shouldShowPremiumPlaceholder(index)"
                                        data-target="#profile-image-slider"
                                        :data-slide-to="index + 1" :key="`indicator-premium-${index}`"
                                        :class="[`carousel-indicator-item-${index + 1}`]">
                                            <PremiumContentThumbnailPlaceholderComponent class="d-none d-md-flex"/>
                                    </li>
                                    <!-- Private Gallery Purchase end -->
                                </template>

                            </ol>

                            <span v-if="showScrollArrows"
                                  class="carousel-arrow-indicator carousel-arrow-indicator--down" @click="carouselNext">
                                <icon-component :icon="fa_angle_down()"></icon-component>
                            </span>
                        </div>

                        <div class="carousel-inner">

                            <template v-for="(photo, i) in photosToShow">

                                <!-- Regular Photo -->
                                <div class="carousel-item" :class="{active:i===0}" :key="i"
                                     @click="openFancyBox(i, photo, photo.video_id)">
                                    <span class="private-gallery-image-banner"
                                          :class="{'offset': isGoldUser(user) || isVipPunterVisitor}"
                                          v-if="photo.galleryId">
                                        <img src="/images/privatgallerie_icon.png" alt=""/>
                                    </span>

                                    <template v-if="photo.video_id">
                                        <explicit-photo-placeholder v-if="isMediaExplicit(photo)"
                                                                    verificationOrigin="gallery"
                                                                    :profileUserId="user.id"
                                                                    class="explicit-photo-placeholder--profile"
                                                                    :is-video="true"
                                                                    e2e-id="profile-photo-explicit"
                                        >
                                        </explicit-photo-placeholder>

                                        <picture v-else e2e-id="profile-video" class="video-block">
                                            <source media="(min-width:300px)" type="image/webp"
                                                    :srcset="getVideoThumbnailUrl(user,'webp','medium',photo)">
                                            <source media="(max-width:300px)" type="image/webp"
                                                    :srcset="getVideoThumbnailUrl(user,'webp','50',photo)">
                                            <source :srcset="getVideoThumbnailUrl(user,'webp','25',photo)"
                                                    type="image/webp">

                                            <source media="(min-width:300px)" type="image/jpeg"
                                                    :srcset="getVideoThumbnailUrl(user,'jpg','medium',photo)">
                                            <source media="(max-width:300px)" type="image/jpeg"
                                                    :srcset="getVideoThumbnailUrl(user,'jpg','50',photo)">
                                            <source :srcset="getVideoThumbnailUrl(user,'jpg','25',photo)"
                                                    type="image/jpeg">

                                            <img :src="getVideoThumbnailUrl(user,'jpg','medium',photo)"
                                                 :alt="'Video #'+(i+1)">

                                            <div class="profile-video-container">
                                                <div class="profile-video-block">
                                                    <button class="profile-video-button">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                                             fill="currentColor" aria-hidden="true">
                                                            <path
                                                                d="M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </picture>
                                    </template>

                                    <template v-else-if="!photo.galleryId">
                                        <explicit-photo-placeholder v-if="isMediaExplicit(photo)"
                                                                    verificationOrigin="gallery"
                                                                    :profileUserId="user.id"
                                                                    class="explicit-photo-placeholder--profile"
                                                                    e2e-id="profile-photo-explicit">
                                        </explicit-photo-placeholder>
                                        <picture v-else e2e-id="profile-photo">
                                            <source media="(min-width:300px)" type="image/webp"
                                                    :srcset="getPhotoUrl(user,'webp','',i, true)">
                                            <source media="(max-width:300px)" type="image/webp"
                                                    :srcset="getPhotoUrl(user,'webp','50',i, true)">
                                            <source :srcset="getPhotoUrl(user,'webp','25',i, true)" type="image/webp">

                                            <source media="(min-width:300px)" type="image/jpeg"
                                                    :srcset="getPhotoUrl(user,'jpg','',i, true)">
                                            <source media="(max-width:300px)" type="image/jpeg"
                                                    :srcset="getPhotoUrl(user,'jpg','50',i, true)">
                                            <source :srcset="getPhotoUrl(user,'jpg','25',i, true)" type="image/jpeg">

                                            <img :src="getPhotoUrl(user,'jpg','',i, true)" :alt="'Photo #'+(i+1)">
                                        </picture>
                                    </template>

                                    <picture v-else-if="photo.galleryId">
                                        <source media="(min-width:300px)" type="image/webp"
                                                :srcset="photo.urls.default.webp">
                                        <source media="(max-width:300px)" type="image/webp"
                                                :srcset="photo.urls.default50.webp">
                                        <source :srcset="photo.urls.default25.webp" type="image/webp">

                                        <source media="(min-width:300px)" type="image/jpeg"
                                                :srcset="photo.urls.default.jpg">
                                        <source media="(max-width:300px)" type="image/jpeg"
                                                :srcset="photo.urls.default50.jpg">
                                        <source :srcset="photo.urls.default25.jpg" type="image/jpeg">

                                        <img :src="photo.urls.default25.jpg" :alt="'Photo'">
                                    </picture>
                                </div>
                                <!-- Regular Photo end -->

                                <!-- Private Gallery Purchase (single slide for all galleries) -->
                                <div class="carousel-item" v-if="shouldShowPremiumPlaceholder(i)"
                                     :key="`premium-slide-${i}`">
                                    <div class="private-gallery-container w-100 private-gallery-purchase">
                                        <GemOutlineComponent class="private-gallery-container--gem1" width="445px"
                                                             height="350px"/>
                                        <GemOutlineComponent class="private-gallery-container--gem2" width="445px"
                                                             height="350px"/>

                                        <div class="private-gallery-container--content">
                                            <div class="heading">
                                                <GemFilledComponent/>
                                                <span>{{ translate.product.premiumAndCustomContent }}</span>
                                            </div>

                                            <p class="subheading">{{
                                                    isVideoUploadEnabled ? translate.home.unlockPremiumContentDescription : translate.home.unlockPremiumContentDescriptionPhotosOnly
                                                }}</p>

                                            <div class="details my-3">
                                                <div>
                                                    <span>{{
                                                            totalPremiumPhotos > 1 ? translate.product.galleryPremiumPhotos[1] : translate.product.galleryPremiumPhotos[0]
                                                        }}</span>
                                                    <span>{{ totalPremiumPhotos }}</span>
                                                </div>

                                                <div v-if="isVideoUploadEnabled">
                                                    <span>{{
                                                            totalPremiumVideos > 1 ? translate.product.galleryPremiumVideos[1] : translate.product.galleryPremiumVideos[0]
                                                        }}</span>
                                                    <span>{{ totalPremiumVideos }}</span>
                                                </div>
                                            </div>

                                            <div class="actions">
                                                <button class="btn btn-rebrand-primary btn-rebrand-sm"
                                                        @click.prevent="subscribeModalLogic()">{{
                                                        translate.home.unlockPremiumNow
                                                    }}
                                                </button>
                                                <button v-if="isRequestContentButtonVisible"
                                                        class="btn btn-rebrand-primary btn-rebrand-sm"
                                                        @click.prevent="onRequestCustomContentClick()">{{
                                                        translate.account.requestCustomContent
                                                    }}
                                                </button>
                                            </div>
                                        </div>
                                        <picture v-if="firstUnpurchasedGallery && firstUnpurchasedGallery.defaultPhoto">
                                            <source :srcset="firstUnpurchasedGallery.defaultPhoto.urls.jpg"
                                                    type="image/jpg">
                                            <img :alt="'Photo'" :src="firstUnpurchasedGallery.defaultPhoto.urls.jpg">
                                        </picture>
                                    </div>
                                </div>
                                <!-- Private Gallery Purchase end -->

                            </template>
                            <div v-if="profileUserIsCurrentUserAndBlurred" class="carousel-locked-icon">
                                <icon-component :icon="fa_lock()" class="fa-lock"></icon-component>
                            </div>
                        </div>
                    </span>
                            <span v-else class="profile-image-wrapper">
                        <div class="carousel-inner w-100">
                            <div class="carousel-item active">
                                <img class="d-block w-100" :src="noPhotoUrl" alt="First slide">
                            </div>
                        </div>
                    </span>

                            <button v-if="isRequestContentButtonVisible"
                                    class="request-custom-content-button d-md-none"
                                    @click="onRequestCustomContentClick">
                                {{ translate.account.requestCustomContent }}
                            </button>
                        </div>

                        <escort-mobile-gallery-subscribe-block class="profile-media-gallery--blocks--mobile d-md-none"
                                                               :user="user"
                                                               @gallerySubscribeClick="subscribeModalLogic"
                                                               @freeVideoClick="openFreeVideoFancybox"/>
                    </div>
                    <div class="main-profile-container--details d-flex flex-column d-sm-block">
                        <div class="profile-page-heading mb-sm-4 order-first">
                            <div class="profile-page-badges"
                                 v-if="isAvailableToday || isGoldUser(user) || isVipPunterVisitor">
                                <span class="small-banner gold" v-if="isGoldUser(user)">
                                    <icon-component :icon="fa_stars()"></icon-component>
                                    {{ translate.product.gold }}
                                </span>
                                <span class="small-banner gold" v-if="isVipPunterVisitor">
                                    {{ translate.product.vip }}
                                    <icon-component width="1.25em" :icon="fa_crown()"></icon-component>
                                </span>
                                <span v-if="isAvailableToday" class="small-banner available"
                                      e2e-id="available-today-profile-banner">
                                    <icon-component :icon="fa_calendar()"></icon-component>
                                    {{ translate.account.availableToday }}
                                </span>
                            </div>

                            <div class="profile-username-row mb-0" v-if="user && user.username"
                                 :class="{'no-location': !hasLocation, 'has-display-address': !!user.display_address}">
                                <h1 class="profile-username">{{ user.username }}</h1>
                                <span v-if="user.verification_status" class="small-banner verified-v2 small">
                                    <icon-component :icon="checkBadge()"/>
                                    <span>{{ translate.account.verified }}</span>
                                </span>
                                <span class="small-banner new small" v-if="isNewProfile">
                                    <icon-component :icon="fa_clock()"/>
                                    <span>{{ translate.home.new }}</span>
                                </span>
                                <span class="small-banner agency small" v-if="!user.is_venue && user.escorts_profile && user.escorts_profile.is_independent === false">
                                    <icon-component :icon="agencyIcon()"/>
                                    <span>{{ translate.account.agency }}</span>
                                </span>

                                <a v-if="showFavoriteIcon" @click="favorite" class="small-banner favorite ml-auto">
                                    <icon-component width="14px" height="10px" :class="{'active': isFavoriteProfile}"
                                                    :icon="fa_heart_bold()"/>
                                </a>
                            </div>

                            <p class="profile-display-address" v-if="user && user.display_address">
                                {{ user.display_address }}
                            </p>

                            <div class="profile-location-online-wrapper">
                                <p v-if="user && hasLocation"
                                   class="location">
                                    <icon-component :icon="mapPin()" width="14px" height="14px"/>
                                    <span v-if="user.city && user.suburb">{{ profileLocation }}</span>
                                    <span v-else>{{ user.suburb || user.city }}</span>
                                </p>

                                <span v-if="user && user.isOnline" class="small-banner online">
                                    {{ translate.home.onlineNow }}
                                </span>
                                <span v-else-if="user && user.last_login && getUserOnlineStatus.length" class="profile-last-online">
                                    <span>{{ translate.home.lastOnline }}:</span>
                                    <span class="d-inline-flex align-items-center" style="gap: 8px" v-html="getUserOnlineStatus"></span>
                                </span>
                            </div>

                            <a class="white-block white-block--website mt-3" @click.prevent="goToWebsite()"
                               :href="getUrl(user.features.websiteUrl)" rel="nofollow"
                               v-if="isGoldUser(user) && user.features && user.features.websiteUrl">
                                <span class="d-flex align-items-center"><icon-component
                                    :icon="fa_globe_americas()"></icon-component> {{
                                        translate.user_features.website_url
                                    }}</span>
                                <b :title="user.features.websiteUrl">{{ user.features.websiteUrl }}</b>
                            </a>
                        </div>

                        <table v-if="isRegularUser(user) && lodash(user,'features.top',false) && topFeatures"
                               class="mb-3" id="profile-features-top">
                            <tbody>

                            <template v-for="([name, value]) in limitedTopFeatures">
                                <tr>
                                    <td><span class="grey-text text-uppercase">{{ translateFeatureName(name) }}</span>
                                    </td>
                                    <td> {{ translateFeatureInProfile(name, value) }}</td>
                                </tr>
                            </template>
                            </tbody>

                            <!-- Currently not needed -->
                            <tfoot v-if="showAdditionalFeatures(user) && false">
                            <tr>
                                <td colspan="2" class="text-center">
                                    <u @click.prevent="onShowAllClickDesktop()"
                                       class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2">
                                        <span>{{ translate.account.seeMore }}</span>
                                    </u>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                        <div id="profile-page-actions-position">
                            <!-- Used to calculate correct point when make #profile-page-actions fixed on mobile -->
                        </div>
                        <div id="profile-page-actions" class="profile-page-actions mb-3 mb-sm-4 order-first">
                            <user-profile-contact-actions :user="user"
                                                          ref="contactActions"
                                                          :isSeekingServicesProfile="isSeekingServicesProfile"
                                                          @call-click="onCallClick"
                                                          @show-login-modal="showLoginModal"
                                                          :profile-is-locked="blurLockedProfile || profileUserIsCurrentUserAndBlurred"
                                                          @showLockedProfileModal="showModalBlurredProfile"
                                                          @show-advert-popup="onShowAdvertPopup"
                            >
                            </user-profile-contact-actions>


                            <p class="profile-warning-dont-send-money" v-if="!isSeekingServicesProfile">
                                {{ translate.home.mentionUsFinding }}
                            </p>

                            <div class="report-problem d-none d-sm-block">
                                <a href="#" @click.prevent="reportProfile">
                                    <icon-component :icon="alarm()" width="16px" height="16px"/>
                                    <span>{{ translate.account.report }}</span>
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div v-if="!isSeekingServicesProfile" class="col-md-12 mb-3">
                <div class="tip-review-banners-row">
                    <div class="tip-leave-banner">
                        <span class="tip-leave-banner__text">{{ translate.home.haveYouUsedProvidedServices }}</span>
                        <a href="#" @click.prevent="openWriteReviewModal()"
                           class="btn btn-rebrand-sm btn-tip-me tip-leave-banner__button">
                            {{ translate.account.reviews.writeReview }}
                        </a>
                    </div>
                    <div class="tip-leave-banner">
                        <span class="tip-leave-banner__text">{{ translate.account.tips.showYourAppreciation }}</span>
                        <a href="#" @click.prevent="openTipSelectAmountModal()"
                           class="btn btn-rebrand-sm btn-tip-me tip-leave-banner__button">
                            {{ translate.account.tips.sendTip }}
                            <CoinSolidComponent width="14px" height="14px"/>
                        </a>
                    </div>
                </div>
            </div>

            <escort-gallery-subscribe-block id="escortGallerySubscribeBlock" class="profile-scroll-target" :user="user"
                                            @gallerySubscribeClick="subscribeModalLogic"
                                            @freeVideoClick="openFreeVideoFancybox"
                                            @requestCustomContentClick="onRequestCustomContentClick">
            </escort-gallery-subscribe-block>

            <premium-galleries-section
                :user="user"
                :visible="showGalleriesSection"
                @viewGallery="openGalleryContents"
                @purchaseGallery="subscribeModalLogic"
                @purchaseAll="openPurchaseAllModal"
                @close="showGalleriesSection = false"
            />

            <map-component id="profile-map-section" class="profile-scroll-target" @refreshMap="refreshMap"
                           :show-map="showMap"
                           :user="user" :show-outcall-location="showOutcallLocation" ref="mapComponent"></map-component>

            <EscortPricesInProfileComponent id="profile-prices-section" class="profile-scroll-target"
                                            :prices="lodash.get(user,'prices',[])"></EscortPricesInProfileComponent>

            <div v-if="allFeaturesEntries.length > 0" class="col-md-12 mb-4" id="profile-features-accordion">
                <div class="container-box">
                    <div class="container-box-title">{{ translate.account.allFeatures }}</div>
                    <div class="container-box-content" id="profile-page-all-features">
                        <table id="profile-features-additional" :class="{'mobile-expanded': mobileAccordionExpanded}">
                            <tbody>
                            <template v-for="([name, value], index) in allFeaturesEntries">
                                <tr :class="{'mobile-hidden-row': index >= 6}">
                                    <td :id="`${name}-key`">
                                        <span class="grey-text text-uppercase">{{ translateFeatureName(name) }}</span>
                                    </td>
                                    <td :id="`${name}-value`">{{ translateFeatureInProfile(name, value) }}</td>
                                </tr>
                            </template>
                            </tbody>
                            <tfoot v-if="hasMoreThanSixFeatures && !mobileAccordionExpanded"
                                   class="d-table-footer-group d-sm-none">
                            <tr>
                                <td colspan="2" class="text-center">
                                    <u class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2"
                                       @click="onExpandMobileAccordion">
                                        {{ translate.account.seeMore }}
                                    </u>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <about-me id="profile-about-section" class="profile-scroll-target" :about-me="getAboutMe()"></about-me>

            <escort-working-hours :working-hours="lodash.get(user,'working_hours',[])"></escort-working-hours>

            <escort-services id="profile-services-section" class="profile-scroll-target"
                             :services="lodash.get(user,'services',[])"></escort-services>

            <reviews-component id="profile-reviews-section" class="profile-scroll-target" v-if="user" :user="user"
                               ref="reviewsComponent"></reviews-component>

            <faq-list v-if="user" :user="user"/>

            <profile-adverts v-if="showAdvertProfilesBanner()" :adverts="user.profileAdverts"/>
        </div>


        <promoted-profiles v-if="showPromotedProfilesBanner()"
                           :promotedProfiles="user.related_promoted_profiles"
                           :promotedOnProfileResultsId="user.promoted_on_profile_results_id"
                           @on-profile-click="onProfileClick">
        </promoted-profiles>
    </div>

</template>

<script>
import {scrollToElement} from "@/core/utils/helpers/scrollHelpers";
import swipe from "@/scripts/jQuery/carouselSwipe";
import photoMixin from "@/components/mixins/photoMixin";
import ModalReportProfileComponent from "@/components/users/modals/ModalReportProfileComponent";
import ModalWriteReviewComponent from "@/components/users/modals/ModalWriteReviewComponent";
import userMixin from "@/components/mixins/userMixin";
import favoriteProfilesMixin from "@/components/mixins/punter/favoriteProfilesMixin";
import ProfileReviewsComponent from "@/components/users/partials/profile_reviews/ProfileReviewsComponent";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import InactiveProfileBannerComponent from "@/components/users/partials/InactiveProfileBannerComponent";
import UserProfileContactActionsComponent from "@/components/users/partials/UserProfileContactActionsComponent";
import xtrackingMixin from '@/components/mixins/xtrackingMixin';
import ExplicitPhotoPlaceholderComponent from "@/components/partials/ExplicitPhotoPlaceholderComponent";
import UserRelatedPromotedProfilesComponent from "@/components/users/partials/UserRelatedPromotedProfilesComponent";
import ModalBlurredProfileComponent from "@/components/users/ModalBlurredProfileComponent";
import ModalProfileAdvertPopUpComponent from "@/components/users/profile/partials/ModalProfileAdvertPopUpComponent.vue";
import userProfileMediaMixin from "@/components/mixins/profile/userProfileMediaMixin";
import FaqInProfileComponent from "@/components/users/profile/partials/FaqInProfileComponent";
import AdvertProfileComponent from "@/components/users/profile/partials/AdvertProfileComponent";
import ProfileHeaderNavigationComponent from "@/components/users/profile/partials/ProfileHeaderNavigationComponent";
import AboutMeInProfileComponent from "@/components/users/profile/partials/AboutMeInProfileComponent";
import MapInProfileComponent from "@/components/users/profile/partials/MapInProfileComponent";
import EscortWorkingHoursInProfileComponent
    from "@/components/users/profile/partials/escort/EscortWorkingHoursInProfileComponent";
import EscortPricesInProfileComponent from "@/components/users/profile/partials/escort/EscortPricesInProfileComponent";
import EscortServicesInProfileComponent
    from "@/components/users/profile/partials/escort/EscortServicesInProfileComponent";
import OutcallLocationInProfileComponent from "@/components/users/profile/partials/OutcallLocationInProfileComponent";
import userProfileMixin from "@/components/mixins/profile/userProfileMixin";
import ModalSubscribeToPrivateGalleryComponent from "@/components/users/modals/ModalSubscribeToPrivateGalleryComponent";
import ModalLoginOrRegisterForPrivateGallery from "@/components/users/modals/ModalLoginOrRegisterForPrivateGallery";
import EscortProfileGalleryBlockComponent from "@/components/users/partials/EscortProfileGalleryBlockComponent";
import ModalPrivateGalleryContentsComponent from "@/components/users/modals/ModalPrivateGalleryContentsComponent";
import ModalPurchaseAllGalleriesComponent from "@/components/users/modals/ModalPurchaseAllGalleriesComponent";
import PremiumGalleriesSectionComponent from "@/components/users/profile/partials/PremiumGalleriesSectionComponent";
import translateMixin from "@/components/mixins/translateMixin";
import {isEscortAvailableToday} from "@/core/utils/helpers/users/escort/escortHelpers";
import ProfileBlurredBannerComponent from "@/components/partials/ProfileBlurredBannerComponent.vue";
import ModalYourProfileIsBlurred from "@/components/users/account/ModalYourProfileIsBlurred.vue";
import {
    agencyIcon,
    alarm,
    checkBadge,
    fa_angle_down,
    fa_angle_up,
    fa_calendar,
    fa_clock,
    fa_crown,
    fa_globe_americas,
    fa_heart,
    fa_heart_bold,
    fa_lock,
    fa_lock_open_alt,
    fa_stars,
    fa_users,
    mapPin,
} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import GemOutlineComponent from "@/components/global/icons/GemOutlineComponent.vue";
import ModalGalleryGuestPurchaseSuccess from "@/components/users/modals/ModalGalleryGuestPurchaseSuccess";
import {getJsonCookie} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";
import {regionRelativeUrl, isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";
import PremiumContentThumbnailPlaceholderComponent
    from "@/components/partials/PremiumContentThumbnailPlaceholderComponent.vue";
import GemFilledComponent from "@/components/global/icons/GemFilledComponent.vue";

import EscortProfileMobileGalleryBlockComponent
    from "@/components/users/partials/EscortProfileMobileGalleryBlockComponent.vue";
import ProfileBreadcrumbsComponent from "@/components/users/profile/partials/ProfileBreadcrumbsComponent.vue";
import ModalPunterLoginOrRegisterComponent from "@/components/global/ModalPunterLoginOrRegisterComponent.vue";
import CoinSolidComponent from "@/components/global/icons/CoinSolidComponent.vue";
import ModalTipSelectAmountComponent from "@/components/users/modals/ModalTipSelectAmountComponent.vue";
import ModalTipConfirmPurchaseComponent from "@/components/users/modals/ModalTipConfirmPurchaseComponent.vue";
import ModalTipSuccessComponent from "@/components/users/modals/ModalTipSuccessComponent.vue";
import ModalTipAuthComponent from "@/components/users/modals/ModalTipAuthComponent.vue";
import {googleTagManager} from "@/core/utils/helpers/googleTagManager";

const data = () => ({
    lodash: _,
    store: $store,
    moment: moment,
    loadingSuccess: false,
    showAllMobile: true,
    topFeatures: null,
    mobileAccordionExpanded: false,
    map: {
        holder_ref: "mapComponent.$refs.map",
        zoom: 14,
        styles: constants.user_map_style,
    },
    mapObject: null,
    noPhotoUrl: constants.user_photo.NO_PHOTO_SEARCH_URL,
    explicitThumbnailUrl: constants.user_photo.EXPLICIT_PHOTO_PLACEHOLDER_SMALL,
    explicitThumbnailVideoUrl: constants.user_photo.EXPLICIT_VIDEO_PLACEHOLDER_SMALL,
    showScrollArrows: false,
    fancyboxLoaded: false,
    fancyboxIndex: null,
    mapLoaded: false,
    unSubscribe: null,
    intervalIdentifier: null,
    intervalDebounceTime: 100,
    showAllPhotos: false,
    carouselLoadAfterInterval: 1000,
    componentInitialized: false,
    debounceTime: 500,
    galleryGuestInformation: null,
    showGalleriesSection: false,
    showAdvertPopup: false,
    advertPopupResolve: null,
});

function initializeComponent() {
    window.scrollTo(0, 0);
    swipe();

    this.initializePhotoScroll();

    $.getScript({url: regionRelativeUrl('/js/jquery.fancybox.min.js', true), cache: true}).then(() => {
        utils.injectCSS('/css/jquery.fancybox.min.css');
        this.fancyboxLoaded = true;
        if (this.fancyboxIndex !== null) {
            this.showFancybox(this.fancyboxIndex, this.user);
        }
    });

    $.getScript({url: regionRelativeUrl('/js/leaflet.js', true), cache: true}).then(() => {
        this.configureMap();
    });

    window.addEventListener('resize', this.initializePhotoScroll);
    window.addEventListener('orientationchange', this.initializePhotoScroll);
    window.addEventListener('popstate', this.refreshComponent);

    this.$nextTick(() => {
        if (typeof $('.carousel').carousel === 'function') {
            $('.carousel').carousel('dispose');
        }

        const DOMIsLoaded = /complete|interactive|loaded/.test(document.readyState);
        if (DOMIsLoaded) {
            this.showAllProfilePhotos();
            this.checkIfGalleryGuestPurchaseSuccess();
            this.checkIfTippedSuccessfully();
        } else {
            window.addEventListener('DOMContentLoaded', (event) => {
                this.showAllProfilePhotos();
                this.checkIfGalleryGuestPurchaseSuccess();
                this.checkIfTippedSuccessfully();
            });
        }

        this.componentInitialized = true;
    });
}

function checkIfGalleryGuestPurchaseSuccess() {
    const queryParam = _.get(this, '$route.query.guestGalleryPurchased');

    if (!queryParam) {
        return;
    }

    const purchasedGalleries = getJsonCookie(CookiesEnum.PURCHASED_GUEST_GALLERIES);
    const userGalleries = _.get(this, 'user.galleries', []);

    if (!purchasedGalleries || !Array.isArray(purchasedGalleries) || !userGalleries.length) {
        return;
    }

    const purchasedIds = String(queryParam).split(',').map(Number);
    const isAllPurchase = purchasedIds.length > 1;

    const matchingCookieEntries = purchasedGalleries.filter(item => purchasedIds.includes(item.galleryId));

    if (!matchingCookieEntries.length) {
        return;
    }

    let galleryDetails;
    let code = matchingCookieEntries[0].code;

    if (isAllPurchase) {
        const matchingGalleries = userGalleries.filter(g => purchasedIds.includes(g.id));
        galleryDetails = {
            username: this.user.username,
            photoQuantity: matchingGalleries.reduce((sum, g) => sum + (g.photoQuantity || 0), 0),
            videoQuantity: matchingGalleries.reduce((sum, g) => sum + (g.videoQuantity || 0), 0),
            prices: _.get(matchingGalleries, '0.prices', [{days: 7}]),
        };
    } else {
        galleryDetails = userGalleries.find(g => g.id === purchasedIds[0]);
        if (!galleryDetails) {
            return;
        }
        galleryDetails.username = this.user.username;
    }

    this.galleryGuestInformation = matchingCookieEntries[0];

    const subscriptionId = matchingCookieEntries[0].subscriptionId || null;
    this.$refs.galleryGuestPurchaseSuccess.initModal(galleryDetails, code, subscriptionId);

    this.$router.replace({query: null});
}

function refreshComponent() {
    if (this.mapObject) {
        this.mapObject.remove();
        this.mapObject = null;
        this.mapLoaded = false;
    }

    if (this.$route.query.galleryId || this.$route.query.galleryAll) {
        const query = {...this.$route.query};
        delete query.galleryId;
        delete query.galleryAll;
        this.$router.replace({query});
    }

    this.store.commit('setLoading', true);
    this.fetchUser();
}

function onProfileClick() {
    this.refreshComponent();
}

function initializeUsersData() {
    this.topFeatures = _.cloneDeep(_.get(this, 'user.features.top', null));
    this.$emit('user-initialised', this.user);
}

function onShowAllClickMobile(event) {
    if (_.get(this.user, 'features.additional', false)) {
        event.preventDefault();
        this.showAllMobile = false;
        _.merge(this.topFeatures, this.user.features.additional);
        this.$forceUpdate();
    }
}

function onShowLessClickMobile(event) {
    event.preventDefault();
    this.showAllMobile = true;
    this.topFeatures = _.cloneDeep(_.get(this, 'user.features.top', null));
    this.$forceUpdate();
}

function showPromotedProfilesBanner() {
    return false;
    // don't show the promoted profiles banner if the user has premium (gold) or plus (silver) status
    if (this.isGoldUser(this.user) || this.isSilverUser(this.user)) {
        return false;
    }

    // the banner is visible only for offering services type of profiles
    if (this.isSeekingServicesProfile) {
        return false;
    }

    // show only if the related promoted profiles are loaded
    return (this.user && this.user.related_promoted_profiles && this.user.related_promoted_profiles.length > 0);
}

function showAdvertProfilesBanner() {
    if (this.isVipPunter) {
        return false;
    }

    return _.get(this, 'user.profileAdverts', []).length > 0;
}

function onShowAllClickDesktop() {
    const targetElement = document.getElementById('profile-features-accordion');
    if (!targetElement) {
        return;
    }
    targetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
}

function translateFeatureName(name) {
    const key = _.toLower(_.replace(name, ' ', '_'));
    return _.get(this, `translate.user_features.${key}`, name);
}

function showAdditionalFeatures(user) {
    if (this.isRegularUser(user) && _.get(user, 'features.additional', false)) {
        return _.compact(_.values(user.features.additional)).length > 0;
    }
    return false;
}

function initializePhotoScroll() {
    if (typeof window !== 'undefined') {
        const photosData = this.getPhotosScrollData();
        const userPhotosCount = _.get(this, 'user.photos', []).length;

        if (userPhotosCount > photosData.photosPerView) {
            this.showScrollArrows = true;
            const carouselElement = $("#profile-image-slider");
            carouselElement.off('slide.bs.carousel').on('slide.bs.carousel', (event) => {
                this.scrollToImg(event.to + 1);
            });
        }
    }
}

function refreshMap() {
    if (this.mapObject) {
        this.mapObject._onResize();
    }
}

function openFancyBox(index, photo) {
    if (this.isMediaExplicit(photo)) {
        return;
    }

    this.fancyboxIndex = index;
    // show fancybox if it's already loaded (async)
    // otherwise, $.getScript will trigger the `showFancybox` by using `this.fancyboxIndex`
    if (this.fancyboxLoaded) {
        this.showFancybox(this.fancyboxIndex, this.user);
    }
}

function getAboutMe() {
    return _.get(this.user, 'features.about_me', false);
}

function profileLocation() {
    const city = _.get(this, 'user.city');
    const suburb = _.get(this, 'user.suburb');

    if (isUnitedKingdomRegion()) {
        return `${city}, ${suburb}`;
    }

    return `${suburb}, ${city}`;
}

function onRequestCustomContentClick() {
    this.$refs.contactActions.onRequestCustomContentClick();
}

function setTitle() {
    if (typeof document != 'undefined') {
        let title = '';
        const username = _.get(this, 'user.username', '');

        if (this.isSeekingServicesProfile && !isUnitedKingdomRegion()) {
            title = `${username} | Erobella`;
        } else {
            title = this.fillTranslateParams(
                this.translate.home.profileMetaTitle, {
                    username: username,
                    city: (_.get(this, 'user.city') || _.get(this, 'user.suburb') || this.countryName),
                    phone: (_.get(this, 'user.phone', false) && !_.get(this, 'user.phone_private', false) ? ` -${_.get(this, 'user.phone', false)}` : ''),
                });
        }

        title = title.replace('  ', ' '); // remove extra space

        document.title = title;
    }
}

function subscribeModalLogic(privateGallery) {
    const allGalleries = _.get(this, 'user.galleries', []);

    if (!privateGallery && allGalleries.length > 1) {
        this.showGalleriesSection = true;
        setTimeout(() => {
            scrollToElement('#premiumGalleriesSection');
        });
        return;
    }

    if (!privateGallery && allGalleries.length === 1) {
        privateGallery = allGalleries[0];
    }

    if (!privateGallery) {
        return;
    }

    if (privateGallery.purchased) {
        this.openGalleryContents(privateGallery);
        return;
    }

    privateGallery.username = this.user.username;

    if (!this.isLoggedIn) {
        /** @see ModalLoginOrRegisterForPrivateGallery.initModal */
        this.$refs.loginOrRegisterModal.initModal(privateGallery);
    } else if (this.isPunter) {
        /** @see ModalSubscribeToPrivateGalleryComponent.initModal */
        this.$refs.privateGalleryModal.initModal(privateGallery);
    }
}

function shouldShowPremiumPlaceholder(index) {
    if (!this.hasGalleries) {
        return false;
    }
    const photosCount = _.get(this, 'user.photos.length', 0) + _.get(this, 'user.videos.length', 0);
    return index === 1 || (photosCount < 2 && index === photosCount - 1);
}

function getPhotosRealPosition(index) {
    return index > 1 ? index + this.showedGalleryCount : index;
}

function convertLanguagesToString() {
    const additionalLanguages = _.get(this.user, 'features.additional.languages');
    if (Array.isArray(additionalLanguages)) {
        this.user.features.additional.languages = _.get(this.user, 'features.additional.languages', []).join(', ');
    }
}

function favorite() {
    googleTagManager.gtmEvent('favourite-button-click', this.user.id, this.blurLockedProfile || this.profileUserIsCurrentUserAndBlurred);

    if (this.isFavoriteProfile) {
        this.trackEvent('profile', 'remove_from_favorites', 'click');
        this.removeFavoriteProfile(this.user.id);
    } else {
        this.trackEvent('profile', 'add_to_favorites', 'click');
        this.addFavoriteProfile(this.user.id);
    }
}

function goToWebsite() {
    let finalUrl = this.getUrl(this.user.features.websiteUrl)

    this.captureTrackingEvent(this.currentUser, 'profile', 'escort_external_link', 'click')
    window.open(finalUrl, '_blank').focus();
}

function openFreeVideoFancybox() {
    if (!this.isLoggedIn) {
        $('#modalNotLoggedIn').modal('show');
        return;
    }

    const videos = _.get(this, 'user.videos', []).filter(v => v.video_id);
    if (!videos.length || !this.fancyboxLoaded) {
        return;
    }

    const slides = videos.map(video => {
        if (this.isMediaExplicit(video)) {
            return {src: constants.user_photo.EXPLICIT_VIDEO_PLACEHOLDER};
        }
        return this.buildVideoIframeHtml(video.video_id);
    });

    $.fancybox.open(slides, {
        loop: false,
        buttons: ['close'],
    });
}

function openGalleryContents(gallery) {
    if (this.$refs.galleryContentsModal) {
        this.$refs.galleryContentsModal.initModal(gallery);
    }
}

function openPurchaseAllModal() {
    const galleries = _.get(this, 'user.galleries', []).filter(g => !g.purchased);
    if (!this.isLoggedIn) {
        const firstGallery = galleries[0];
        if (firstGallery) {
            const totalPrice = galleries.reduce((sum, g) => sum + _.get(g, 'prices.0.price', 0), 0);
            const aggregatedGallery = {
                ...firstGallery,
                all: true,
                ownerId: this.user.id,
                username: this.user.username,
                photoQuantity: galleries.reduce((sum, g) => sum + (g.photoQuantity || 0), 0),
                videoQuantity: galleries.reduce((sum, g) => sum + (g.videoQuantity || 0), 0),
                prices: [{days: 7, price: totalPrice}],
            };
            this.$refs.loginOrRegisterModal.initModal(aggregatedGallery);
        }
        return;
    }
    if (this.isPunter && this.$refs.purchaseAllModal) {
        this.$refs.purchaseAllModal.initModal();
    }
}

function onReviewCreated(review) {
    if (this.$refs.reviewsComponent) {
        this.$refs.reviewsComponent.updateReviews(review);
    }
}

function openWriteReviewModal() {
    if (!this.isLoggedIn) {
        $('#modalNotLoggedIn').modal().show();
        return;
    }
    $('#modalWriteReview').modal('show');
}

function openTipSelectAmountModal() {
    this.$refs.tipSelectAmountModal.initModal();
}

function onTipAmountSelected(amount) {
    if (!this.isLoggedIn) {
        this.$refs.tipAuthModal.initModal(this.user, amount);
        return;
    }
    this.$refs.tipConfirmModal.initModal(this.user, amount);
}

function onTipSuccess(amount) {
    this.$refs.tipSuccessModal.initModal(this.user.username, amount);
}

function checkIfTippedSuccessfully() {
    const amount = _.get(this, '$route.query.successfullyTippedAmount');
    if (amount) {
        this.$router.replace({query: _.omit(this.$route.query, ['successfullyTippedAmount'])});
        this.$refs.tipSuccessModal.initModal(this.user.username, amount);
        return;
    }

    const confirmAmount = _.get(this, '$route.query.confirmTipPurchase');
    if (confirmAmount) {
        this.$router.replace({query: _.omit(this.$route.query, ['confirmTipPurchase'])});
        this.$refs.tipConfirmModal.initModal(this.user, Number(confirmAmount));
        return;
    }

    if (this.isLoggedIn) {
        const loginMeta = this.pullLocalStorageObject('loginMeta');
        if (loginMeta && loginMeta.redirectedFrom === 'tipProfileModal') {
            this.$refs.tipConfirmModal.initModal(this.user, Number(loginMeta.tipProfileModalRedirector.tipAmount));
        }
    }
}

function onShowAdvertPopup(resolve) {
    if (this.isVipPunter) {
        resolve(true);
        return;
    }

    this.showAdvertPopup = true;
    this.advertPopupResolve = resolve;
}

function onAdvertPopupSkip() {
    this.showAdvertPopup = false;
    if (this.advertPopupResolve) {
        this.advertPopupResolve(true);
        this.advertPopupResolve = null;
    }
}

function onAdvertPopupClose() {
    this.showAdvertPopup = false;
    if (this.advertPopupResolve) {
        this.advertPopupResolve(false);
        this.advertPopupResolve = null;
    }
}

export default {
    data,
    computed: {
        ...mapState([
            'translate', 'currentUser', 'isSeekingServicesProfile', 'countryName', 'regionData',
        ]),
        isVideoUploadEnabled() {
            return !_.has(this.regionData, 'sectionsToHide.videoUpload');
        },
        getMapHolder() {
            return _.get(this, `$refs.${this.map.holder_ref}`);
        },
        isAvailableToday() {
            return isEscortAvailableToday(this.user);
        },
        showedGalleryCount() {
            return this.hasGalleries ? 1 : 0;
        },
        hasGalleries() {
            return _.get(this, 'user.galleries', []).some(g => g.defaultPhoto);
        },
        hasUnpurchasedGalleries() {
            return _.get(this, 'user.galleries', []).some(g => !g.purchased && g.defaultPhoto);
        },
        totalPremiumPhotos() {
            const galleries = _.get(this, 'user.galleries', []).filter(g => !g.purchased);
            return galleries.reduce((sum, g) => sum + (g.photoQuantity || 0), 0);
        },
        totalPremiumVideos() {
            const galleries = _.get(this, 'user.galleries', []).filter(g => !g.purchased);
            return galleries.reduce((sum, g) => sum + (g.videoQuantity || 0), 0);
        },
        firstUnpurchasedGallery() {
            return _.get(this, 'user.galleries', []).find(g => !g.purchased && g.defaultPhoto);
        },
        isLoadingProfile() {
            return !this.user || (this.user && this.isLoadingPrivateGalleries)
        },
        hasLocation() {
            return (this.user.city && this.user.suburb) || (this.user.suburb || this.user.city)
        },
        profileLocation,
        getUserOnlineStatus() {
            if (!this.user || !this.user.last_login) {
                return '';
            }

            const today = moment();
            const lastLogin = moment(this.user.last_login);
            if (lastLogin.isAfter(today)) {
                return '';
            }

            const diffDays = today.diff(lastLogin, 'days');
            if (diffDays === 0) {
                return '<span class="online-dot"></span> ' + this.translate.home.onlineToday;
            }

            if (diffDays === 1) {
                return this.translate.home.onlineYesterday;
            }

            if (diffDays < 7) {
                return diffDays + ' ' + this.translate.home.onlineDaysAgo;
            }

            return '';

            if (diffDays < 28) {
                const weeks = Math.floor(diffDays / 7);
                const parts = this.translate.home.onlineWeeksAgo.split('|');
                return weeks + ' ' + (weeks === 1 ? parts[0] : parts[1]).trim();
            }

            if (diffDays < 90) {
                const months = Math.floor(diffDays / 30);
                const parts = this.translate.home.onlineMonthsAgo.split('|');
                return months + ' ' + (months === 1 ? parts[0] : parts[1]).trim();
            }

            return this.translate.home.onlineLongTime;
        },
        allFeatures() {
            const top = _.get(this, 'user.features.top', {});
            const additional = _.get(this, 'user.features.additional', {});
            return {...top, ...additional};
        },
        allFeaturesEntries() {
            return Object.entries(this.allFeatures).filter(([name, value]) => value);
        },
        hasMoreThanSixFeatures() {
            return this.allFeaturesEntries.length > 6;
        },
        limitedTopFeatures() {
            if (!this.topFeatures) return [];
            return Object.entries(this.topFeatures).filter(([, value]) => value).slice(0, 6);
        },
        showMap() {
            if (!this.areUserCoordinatesSet) {
                return false;
            }

            const escortsProfile = this.user.escorts_profile;

            if (!escortsProfile) {
                return true;
            }

            const dontMeetsInPerson = escortsProfile && !escortsProfile.meets_in_person && escortsProfile.meets_in_person !== null;

            return !dontMeetsInPerson;
        },
    },
    props: {
        user: {},
        isLoadingPrivateGalleries: Boolean,
    },
    watch: {
        user: {
            immediate: true,
            deep: true,
            handler() {
                if (!this.user) {
                    return;
                }

                // needed to call method from fancybox gallery view
                if (typeof window !== "undefined") {
                    window.subscribeModalLogicJS = (element) => {
                        const gallery = JSON.parse(element.getAttribute('gallery-data'));
                        this.subscribeModalLogic(gallery);
                    };
                }

                // Handle galleryAll query param - open purchase all modal
                if (_.get(this, '$route.query.galleryAll') && this.user.galleries && this.isLoggedIn && this.isPunter) {
                    const query = {...this.$route.query};
                    delete query.galleryAll;
                    this.$router.replace({query});
                    this.$nextTick(() => this.openPurchaseAllModal());
                }
                // Inits logic only if user is logged in, has galleryId in params and profile has private galleries
                else if (_.get(this, '$route.query.galleryId') && this.user.galleries && this.isLoggedIn) {
                    const selectedGallery = this.user.galleries
                        .filter(gallery => gallery.id === Number(this.$route.query.galleryId))
                        .pop();

                    // Open gallery purchase modal if gallery exists and is not already purchased
                    if (selectedGallery && !selectedGallery.purchased) {
                        selectedGallery.username = this.user.username;
                        this.$nextTick(() => this.$refs.privateGalleryModal.initModal(selectedGallery))
                    }
                }

                this.initializeUsersData();
                if (typeof window !== "undefined" && this.user) {
                    this.setTitle();
                    if (!this.componentInitialized) {
                        this.initializeComponent()
                    }
                }
                _.debounce(() => {
                    this.configureMap()
                }, 200)();

                this.convertLanguagesToString();
            },
        },
        'user.galleries.length': {
            handler(newLength) {
                if (newLength > 0) {
                    this.checkIfGalleryGuestPurchaseSuccess();
                }
            },
        },
    },
    mounted() {
        window.addEventListener("scroll", this.isFullyScrolledInView);
    },
    beforeDestroy() {
        this.store.commit('setSearchDoneFromHome', true);
        window.removeEventListener('resize', this.initializePhotoScroll);
        window.removeEventListener('orientationchange', this.initializePhotoScroll);
        window.removeEventListener('DOMContentLoaded', this.showAllProfilePhotos);
        window.removeEventListener('popstate', this.refreshComponent);
        window.removeEventListener("scroll", this.isFullyScrolledInView, {passive: true});
    },
    mixins: [
        photoMixin,
        userMixin,
        favoriteProfilesMixin,
        localStorageMixin,
        xtrackingMixin,
        userProfileMediaMixin,
        userProfileMixin,
        translateMixin,
    ],
    methods: {
        agencyIcon,
        fa_clock,
        fa_users,
        checkBadge,
        fa_calendar,
        fa_stars,
        mapPin,
        alarm,
        fa_lock,
        fa_heart_bold,
        fa_crown,
        fa_angle_down,
        fa_angle_up,
        fa_lock_open_alt,
        fa_heart,
        fa_globe_americas,
        onShowAllClickMobile,
        onShowLessClickMobile,
        onShowAllClickDesktop,
        onRequestCustomContentClick,
        onExpandMobileAccordion() {
            this.mobileAccordionExpanded = true;
        },
        initializeUsersData,
        translateFeatureName,
        showAdditionalFeatures,
        showAdvertProfilesBanner,
        initializePhotoScroll,
        refreshMap,
        openFancyBox,
        refreshComponent,
        onProfileClick,
        showPromotedProfilesBanner,
        getAboutMe,
        setTitle,
        initializeComponent,
        subscribeModalLogic,
        shouldShowPremiumPlaceholder,
        getPhotosRealPosition,
        convertLanguagesToString,
        favorite,
        checkIfGalleryGuestPurchaseSuccess,
        goToWebsite,
        openFreeVideoFancybox,
        onShowAdvertPopup,
        onAdvertPopupSkip,
        onAdvertPopupClose,
        openGalleryContents,
        openPurchaseAllModal,
        onReviewCreated,
        openWriteReviewModal,
        openTipSelectAmountModal,
        onTipAmountSelected,
        onTipSuccess,
        checkIfTippedSuccessfully,
    },
    components: {
        ModalPunterLoginOrRegisterComponent,
        ModalProfileAdvertPopUpComponent,
        GemFilledComponent,
        PremiumContentThumbnailPlaceholderComponent,
        ModalGalleryGuestPurchaseSuccess,
        ModalWriteReviewComponent,
        IconComponent,
        GemOutlineComponent,
        'modal-your-profile-is-blurred': ModalYourProfileIsBlurred,
        'profile-blurred-banner-component': ProfileBlurredBannerComponent,
        'faq-list': FaqInProfileComponent,
        'profile-adverts': AdvertProfileComponent,
        ProfileHeaderNavigationComponent,
        'modal-report-profile': ModalReportProfileComponent,
        'reviews-component': ProfileReviewsComponent,
        'inactive-profile-banner': InactiveProfileBannerComponent,
        'user-profile-contact-actions': UserProfileContactActionsComponent,
        'explicit-photo-placeholder': ExplicitPhotoPlaceholderComponent,
        'promoted-profiles': UserRelatedPromotedProfilesComponent,
        'modal-blurred-profile': ModalBlurredProfileComponent,
        'about-me': AboutMeInProfileComponent,
        'map-component': MapInProfileComponent,
        'escort-working-hours': EscortWorkingHoursInProfileComponent,
        EscortPricesInProfileComponent,
        'escort-services': EscortServicesInProfileComponent,
        'outcall-location': OutcallLocationInProfileComponent,
        'modal-subscribe-to-private-gallery': ModalSubscribeToPrivateGalleryComponent,
        'modal-login-or-register-for-private-gallery': ModalLoginOrRegisterForPrivateGallery,
        'escort-gallery-subscribe-block': EscortProfileGalleryBlockComponent,
        'modal-private-gallery-contents': ModalPrivateGalleryContentsComponent,
        'modal-purchase-all-galleries': ModalPurchaseAllGalleriesComponent,
        'premium-galleries-section': PremiumGalleriesSectionComponent,
        'escort-mobile-gallery-subscribe-block': EscortProfileMobileGalleryBlockComponent,
        ProfileBreadcrumbsComponent,
        CoinSolidComponent,
        ModalTipSelectAmountComponent,
        ModalTipConfirmPurchaseComponent,
        ModalTipSuccessComponent,
        ModalTipAuthComponent,
    },
};
</script>
